import React from 'react'
import { TStrapiV4BenefitsWidget } from '../../common-types'
import Title from '../../common-components/Title'
import BenefitCard from './BenefitCard'

type TProps = TStrapiV4BenefitsWidget

export const StrapiV4BenefitsWidget = (props: TProps) => {
  const { title, cards } = props
  return (
    <div className="bg-brand-grey-background my-8 py-8 xl:my-12 xl:py-12">
      <div className="herolike-wrapper py-8 xl:py-12">
        <Title
          className="mx-auto mb-5 text-center font-semibold lg:mb-8"
          fontSize="size-54"
        >
          {title}
        </Title>
        <div className="flex flex-col space-y-8">
          {cards?.map((card, i) => (
            <div key={i}>
              <BenefitCard {...card} isLeft={i % 2 == 0} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
